import { EditAction } from '../shared/enum/EditAction';
import { ClientClipperFilterModel } from './ClientClipperFilterModel';
import { ClipperModel } from './ClipperModel';

export interface ClientClipperModel {
    id: number,
    clientId: number,
    clipper: ClipperModel | null,
    login: string,
    password: string,
    editAction: EditAction,
    clippingFilters: ClientClipperFilterModel[],
    userId: number | null
}

export const clientClipperModelInitial: ClientClipperModel = {
    id: 0,
    clientId: 0,
    clipper: null,
    login: '',
    password: '',
    editAction: EditAction.NONE,
    clippingFilters: [],
    userId: null
};